import React from 'react';
import { FiArrowRightCircle } from 'react-icons/fi';

import { Container } from './styles';

const Card = ({
	backgroundColor,
	textColor,
	href,
	text = [],
	onClick,
	target = '_blank',
	comingSoon = false,
	children,
	icon,
}) => {
	return (
		<Container
			href={href || null}
			backgroundColor={backgroundColor}
			textColor={textColor}
			target={target}
			onClick={onClick || null}
		>
			{!comingSoon && <FiArrowRightCircle size={22} color={textColor} />}
			{comingSoon && <span>Em Breve</span>}
			<div>
				<h2>
					{icon}
					{text}
				</h2>
			</div>
		</Container>
	);
};

export default Card;
